import React, { useState, useRef, useEffect } from 'react'
import classnames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import styles from './screen.module.less'

export default (props) => {
  const { currentImage, boxIndex, setBoxIndex, boxLabelRetList } = props
  const [refreshValue, refresh] = useState(true)
  const judgeShow = () => {
    refresh(pre => !pre)
  }
  const step = 100
  const $screen = useRef<any>()
  const $prev = useRef<any>()
  const $next = useRef<any>()
  const visibleChange = () => {
    const screen = $screen.current
    const next = $next.current
    const prev = $prev.current
    const scrollTotal = screen.scrollWidth - screen.clientWidth
    prev.style.display = ''
    next.style.display = ''
    if (!scrollTotal) {
      prev.style.display = 'none'
      next.style.display = 'none'
    }
    if ((scrollTotal - screen.scrollLeft) <= 0) {
      next.style.display = 'none'
    }
    if ($screen.current.scrollLeft === 0) {
      prev.style.display = 'none'
    }
  }

  useEffect(() => {
    visibleChange()
    $screen.current?.addEventListener('scroll', visibleChange)
    return () => {
      $screen.current?.removeEventListener('scroll', visibleChange)
    }
  }, [refreshValue])

  useEffect(() => {
    judgeShow()
  }, [JSON.stringify(currentImage)])

  const onClickPrev = () => {
    $screen.current.scrollLeft -= step
    visibleChange()
  }
  const onClickNext = () => {
    $screen.current.scrollLeft += step
    visibleChange()
  }
  return <div className={styles['screen-wrapper']}>
    <div className="screen" ref={$screen}>
      {boxLabelRetList.map((box, index) => <div
        key={index}
        id={`box${index}`}
        className={classnames('screen-item', { active: index === boxIndex })}
        onClick={() => setBoxIndex(index)}
      >{box.category}</div>)}
    </div>
    <div className="arrow-wrapper prev" ref={$prev}><div className="arrow fill-white-bg" onClick={onClickPrev}><Icon type="m-Vxing_zuo" /></div></div>
    <div className="arrow-wrapper next" ref={$next}><div className="arrow fill-white-bg" onClick={onClickNext}><Icon type="m-Vxing_you" /></div></div>
  </div>
}
